import { writable } from "svelte/store";
import toastsStore from "./toastsStore";

const currentVersion = "2025.05.01";

const { subscribe, update } = writable({
	currentVersion,
	correctVersion: null,
	apiVersion: null,
});

function setKeys(obj) {
	update((versions) => {
		for (const [key, value] of Object.entries(obj)) {
			if (value) {
				versions[key] = value;
				if (key === "correctVersion" && value !== currentVersion) {
					toastsStore.addToast({
						text: "Update detected. Please refresh your browser.",
						id: "___refresh___",
						className: "error",
						persist: true,
					});
				}
			}
		}
		return versions;
	});
}

export default { subscribe, setKeys };
